import React, { useState, useEffect } from "react";
import { LockOutlined, EditOutlined, CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import Layout from "../component/Layout";
import UserView from "../pages/UserView/UserView";
import UserAccountActivity from "../pages/UserAccountActivity"
import UserTrainingSearch from "../pages/UserTrainingSearch";
import { useParams } from "react-router";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from "react-redux";
import { fetchEmployeeById, fetchEmployeeDetails } from "../services/Service";
import { updateEmployeeDetails } from "../services/Service";
//import "./viewpage.css";
//import {useAuth} from "../Context/AuthContext";
import { Tabs } from "antd";
import UserAttendedTrainings from "../pages/UserView/User_Attended/UserAttendedTrainings";

const { TabPane } = Tabs;

const ViewPage = () => {
  const { id } = useParams();
  //const{role}=useParams();
  const [userData, setUserData] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [baseLocation, setBaseLocation] = useState("Base Location");
  const [showMessage, setShowMessage] = useState(false);
  const [phoneError, setPhoneError] = useState("");
  const [locationError, setLocationError] = useState("");
  const [loggedInUserRole, setLoggedInUser] = useState(JSON.parse(localStorage.getItem("userRoles"))); // Define loggedInUserRole state
  const token = useSelector((state) => state.auth.token);
  const basePath = sessionStorage.getItem('APP_BASE_PATH')
  //const {user}=useAuth();



  const [activeTabKey, setActiveTabKey] = useState("1"); // Default active tab key

  const handleTabChange = (key) => {
    setActiveTabKey(key);
    console.log(`Selected Tab Key: ${key}`);
  };

  const email = localStorage.getItem("userEmail");


  useEffect(() => {
    const storedRole = JSON.parse(localStorage.getItem("userRoles"));
    // alert(storedRole);
    if (storedRole) {
      setLoggedInUser(storedRole); // ✅ this sets the state properly
    }
    // setLoggedInUser(role);
    //alert(loggedInUserRole);
    const fetchData = async () => {
      try {
        let response;
        // Get email from localStorage
        const email = localStorage.getItem("userEmail"); // No need for JSON.parse()
        if (!email) {
          console.error("No user email found in localStorage.");
          return;
        }
        console.log(loggedInUserRole);
        console.log("Stored Email:", email);

        // Fetch employee details
        if (id) {
          response = await fetchEmployeeById(id);
        }
        else {
          response = await fetchEmployeeDetails(email);
        }
        console.log(response);
        setUserData({
          id: response.uid || "",
          firstName: response.firstName || "",
          middleName: response.middleName || "", // 🟢 Set first name
          lastName: response.lastName || "",    // 🟢 Set last name
          email: response.emailId || "",          // 🟢 Set email
          phoneNumber: response.phoneNumber || "",  // 🟢 Set phone number
          baseLocation: response.baseLocation || "",
          dob: response.dobDay && response.dobMonth ? `${response.dobDay}/${response.dobMonth}` : "",
          doj: response.doj || "",
          obd: response.onBoardingDate || "",
          // dob: response.dob ? new Date(user.dob).toISOString().split("T")[0] : "", // 🟢 Format Date of Birth (YYYY-MM-DD)
        });
        setPhoneNumber(response.phoneNumber || "");
        // Ensure response is not undefined or null
        if (!response) {
          console.error("API response is undefined or null.");
          return;
        }

        // Check if headers exist
        if (!response.headers || typeof response.headers.get !== "function") {
          console.error("Invalid response object:", response);
          return;
        }

        // Check content type
        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          console.error("Response is not in JSON format.");
          return;
        }

        const data = await response.json();

        // Check if response contains 'content'
        if (!data || !data.content) {
          console.error("Invalid API response:", data);
          return;
        }

      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, [id]); // `id` should be a dependency if it changes

  const handleUpdate = async () => {
    if (phoneError) return;

    // Prevent update if no changes are made
    if (phoneNumber === userData.phoneNumber && baseLocation === userData.baseLocation) {
      setIsEditing(false);
      return;
    }

    const updatedData = {
      phoneNumber: phoneNumber || userData.phoneNumber,
      baseLocation: baseLocation || userData.baseLocation,
    };

    try {
      const response = await updateEmployeeDetails(email, updatedData);
      console.log("Update Response:", response);

      // ✅ Update state with the latest data
      setUserData((prevState) => ({
        ...prevState,
        phoneNumber: updatedData.phoneNumber,
        baseLocation: updatedData.baseLocation,  // Update base location in userData
      }));

      setBaseLocation(updatedData.baseLocation); // ✅ Ensures dropdown reflects the latest value

      setIsEditing(false);

      toast.success("Update successful!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });

    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Update failed. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }
  };

  const validatePhoneNumber = (value) => {
    const phoneRegex = /^[0-9]{10}$/; // Allows only 10-digit numbers
    if (!phoneRegex.test(value)) {
      setPhoneError("Phone number must be exactly 10 digits.");
      return false;
    } else {
      setPhoneError("");
      return true;
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhoneNumber(value);
    validatePhoneNumber(value);
  };

  const validateLocation = (value) => {
    if (value === "Select Base Location") {
      setLocationError("Please select a valid location.");
      return false;
    } else {
      setLocationError("");
      return true;
    }
  };


  localStorage.setItem("userrId", userData.id);
  localStorage.setItem("userrname", userData.firstName);
  // Dynamic inline style function
  const getTabStyle = (key) => ({
    color: activeTabKey === key ? "white" : "white",
    fontWeight: "bold",
    fontSize: "18px",
    padding: "5px 20px",
    backgroundColor: activeTabKey === key ? "#1f425b" : "#2c5778",
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
    border: activeTabKey === key ? "2px solid white" : "2px solid transparent",
    borderBottom: activeTabKey === key ? "none" : "2px solid transparent",
    marginBottom: "-2px", // To align with the content area
  });
  return (
    <Layout loggedInUserRole={loggedInUserRole[0]}>

      <Tabs
        defaultActiveKey="1"
        centered
        tabBarStyle={{
          textAlign: "center",
          color: "white",
          fontWeight: "bold",
          fontSize: "16px",
          backgroundColor: "#2c5778",
          height: "60px",
          borderRadius: "12px 12px 0 0",
          padding: "10px 0"
        }}
        className="rounded-lg overflow-hidden"
        activeKey={activeTabKey} onChange={handleTabChange}

      >

        {/* Tab for User Form */}
        <TabPane tab=

          {<span style={getTabStyle("1")}
          >
            Employee Details
          </span>}
          key="1">
          <div className="p-0 rounded-lg mt-0">
            <div className="flex justify-center ">
              <div className="flex ml-0 w-full" style={{ height: '430px' }}>
                <div className={'duration-300 p-0 ml-0 mt-[20px] overflow-y-auto bg-white rounded-[16px] w-[1250px]'}>
                  <div className="flex items-center">
                    <label className="text-sm ml-2 font-medium w-[100px] pr-[110px]">UID</label>
                  </div>
                  <div className="relative ml-2 right-13">
                    <input type="text" value={userData.id} readOnly className="px-3 py-2 border border-gray-300 bg-gray-100 rounded-md text-gray-700 text-sm h-[25px] w-[200px]" />
                    <span className="absolute left-[178px] top-1/2 transform -translate-y-1/2 text-gray-500">
                      <LockOutlined />
                    </span>

                    {/* Render Offboarding Button if the user role is adminuser */}
                    {loggedInUserRole[0] === "ADMINUSER" && (

                      <button type="button" className="relative left-[850px] px-3 mt-[3px] py-2 border bg-[#1f425b] text-white rounded-md hover:bg-blue-900 text-sm w-[180px]">
                        <a href={`${basePath}/offboarding/${userData.id}`} className="text-white">
                          Offboarding
                        </a>
                      </button>

                    )}
                  </div>
                  <br />
                  <div class="flex space-x-7">
                    <div class="flex flex-col space-y-1 ">
                      <label class="text-sm  ml-2 font-medium">First Name</label>
                      <div class="relative">
                        <input type="text" value={userData.firstName} readOnly
                          class="px-3 py-2 ml-2 border border-gray-300 bg-gray-100 rounded-md text-gray-700 text-sm w-full h-[25px]" />
                        <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                          <LockOutlined />
                        </span>
                      </div>
                    </div>
                    <div class="flex flex-col space-y-1">
                      <label class="text-sm font-medium">Middle Name</label>
                      <div class="relative">
                        <input type="text" value={userData.middleName || ""} readOnly
                          class="px-3 py-2 right-3 border border-gray-300 bg-gray-100 rounded-md text-gray-700 text-sm w-full h-[25px]" />
                        <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                          <LockOutlined />
                        </span>
                      </div>
                    </div>
                    <div class="flex flex-col space-y-1">
                      <label class="text-sm font-medium">Last Name</label>
                      <div class="relative">
                        <input type="text" value={userData.lastName || ""} readOnly
                          class="px-3 py-2 border border-gray-300 bg-gray-100 rounded-md text-gray-700 text-sm w-full h-[25px]" />
                        <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                          <LockOutlined />
                        </span>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="flex space-x-7">
                    <div class="flex flex-col">
                      <label class="text-sm ml-2 font-medium mb-1">Email ID</label>
                      <div class="relative">
                        <input type="text" value={userData.email} readOnly
                          class="px-3 py-2 ml-2 border border-gray-300 bg-gray-100 rounded-md text-gray-700 text-sm w-[409px] h-[25px]" />
                        <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                          <LockOutlined />
                        </span>
                      </div>
                    </div>
                    <div class="flex flex-col">
                      <label class="text-sm font-medium mb-1">DOB</label>
                      <div class="relative">
                        <input type="text" value={userData.dob || ""} readOnly
                          class="px-3 py-2 border border-gray-300 bg-gray-100 rounded-md text-gray-700 text-sm w-full h-[25px]" />
                        <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                          <LockOutlined />
                        </span>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="flex space-x-7">
                    <div class="flex flex-col">
                      <label class="text-sm ml-2 font-medium mb-1">DOJ</label>
                      <div class="relative">
                        <input type="text" value={userData.doj ? new Date(userData.doj).toLocaleDateString('en-GB') : ""} readOnly



                          class="px-3 py-2 ml-2 border border-gray-300 bg-gray-100 rounded-md text-gray-700 text-sm w-full h-[25px]" />
                        <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                          <LockOutlined />
                        </span>
                      </div>
                    </div>
                    <div class="flex flex-col">
                      <label class="text-sm font-medium mb-1">Onboarding Date</label>
                      <div class="relative">
                        <input type="text" value={userData.obd ? new Date(userData.obd).toLocaleDateString('en-GB') : ""} readOnly
                          class="px-3 py-2 border border-gray-300 bg-gray-100 rounded-md text-gray-700 text-sm w-full h-[25px]" />
                        <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                          <LockOutlined />
                        </span>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="flex space-x-7">
                    <div class="flex flex-col space-y-1">
                      <label class="text-sm ml-2 font-medium mb-1">Phone Number</label>
                      <div class="relative">
                        <input type="text" value={phoneNumber} readOnly={!isEditing}
                          onChange={handlePhoneChange}
                          className={`px-3 py-2 ml-2 border rounded-md text-sm w-full h-[25px]
      ${isEditing ? "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500" : "bg-gray-100 text-gray-700"}
      ${phoneError ? "border-red-500 focus:ring-red-500" : ""}`}
                        /> <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                          {isEditing ? <EditOutlined /> : <LockOutlined />}
                        </span>
                      </div>
                      {phoneError && (
                        <div className="text-red-500 text-xs flex items-center mt-1">
                          <ExclamationCircleOutlined className="mr-1" />
                          {phoneError}
                        </div>
                      )}
                    </div>


                    <div className="flex flex-col space-y-2">
                      <label className="text-sm ml-2 font-medium">Base Location</label>

                      {isEditing ? (
                        // Editable dropdown when in editing mode
                        <select
                          value={baseLocation || userData.baseLocation}
                          onChange={(e) => {
                            setBaseLocation(e.target.value);
                            validateLocation(e.target.value);
                          }}
                          className={`w-full px-3 py-2 border rounded-md text-sm bg-white focus:ring-2 focus:ring-blue-500 h-[35px]
      ${locationError ? "border-red-500 focus:ring-red-500" : "border-blue-500"}`}
                        >
                          <option value="">Select Base Location</option>
                          <option value="TVM">TVM</option>
                          <option value="Kochi">Kochi</option>
                          <option value="Bangalore">Bangalore</option>
                          <option value="Hyderabad">Hyderabad</option>
                          <option value="Chennai">Chennai</option>
                          <option value="Pune">Pune</option>
                        </select>
                      ) : (
                        // Read-only input when not in editing mode
                        <input
                          type="text"
                          value={userData.baseLocation || ""}
                          readOnly
                          className="px-3 py-2 border border-gray-300 bg-gray-100 rounded-md text-gray-700 text-sm w-full h-[25px]"
                        />
                      )}

                      {/* Error message display */}
                      {locationError && (
                        <div className="text-red-500 text-xs flex items-center mt-1">
                          <ExclamationCircleOutlined className="mr-1" />
                          {locationError}
                        </div>
                      )}
                    </div>
                  </div>
                  <br />
                  <div className="flex space-x-4">
                    {loggedInUserRole[0] === "NORMALUSER" && !isEditing ? (
                      <button className=" px-4 py-1 ml-2 bg-[#1f425b] text-white rounded-md hover:bg-blue-900 transition duration-200"
                        onClick={() => setIsEditing(true)}>
                        Edit
                      </button>
                    ) : loggedInUserRole[0] === "NORMALUSER" && isEditing ? (
                      // Show "Update" button when the logged-in user is a "normaluser" and editing
                      <button
                        className="px-4 py-1 ml-2 bg-[#1f425b] text-white rounded-md hover:bg-blue-900 transition duration-200"
                        onClick={handleUpdate}
                      >
                        Update
                      </button>
                    ) : null}
                  </div>
                  {/* {showMessage && (
              <div className="flex items-center ml-[80px] h-[40px] w-[210px] bg-blue-100 border border-blue-400 text-green-600 rounded-md">
                <CheckCircleOutlined className="mr-1" />
                <span>Update successful!</span>
              </div>
            )} */}
                </div>
              </div>
              <ToastContainer />
            </div>
          </div>

        </TabPane>
        {loggedInUserRole === "superuser" ? (null
        ) : <TabPane tab={<span style={getTabStyle("2")}
        >
          BGV Form
        </span>
        } key="2">



          <div className=" p-0 rounded-lg">
            <UserView />
          </div>

        </TabPane>}

        {/*{loggedInUserRole[0] === "NORMALUSER" ? */
          <TabPane tab={<span style={getTabStyle("3")}>
            Account Activity
          </span>
          } key="3">

            <div className=" p-0 rounded-lg">

              <UserAccountActivity />
            </div>

          </TabPane>/*:(null)}*/}
        {/* {loggedInUserRole[0] === "NORMALUSER" ? 
      <TabPane tab={<span style={getTabStyle("4")}
        >
          Training Portal
        </span>
      } key="4">

<div className=" p-0 rounded-lg">

       <UserTrainingSearch />
       </div>
       
      </TabPane>:(null)}*/}

        {loggedInUserRole[0] ?
          <TabPane tab={<span style={getTabStyle("5")}>
            Attended Trainings
          </span>
          } key="5">

            <div className=" p-0 rounded-lg">

              <UserAttendedTrainings />
            </div>

          </TabPane> : (null)}

      </Tabs>
    </Layout>
  );
};

export default ViewPage;